import { Slide } from '@/components/core/Slide';
import { WebContent } from '@/components/web/WebContent';
import audioFile from './17-ElevenLabs_2024-11-13T12_49_03_Scarlett - Western Narrator_gen_s50_sb75.mp3';
import ffRekenenLogo from './17-ffrekenen.png';
import mastersLogo from './17-masters.jpeg';
import nextgenLogo from './17-nextgen.png';
import styles from './17-requests.module.css';

const transcript = `
  Ik ben klaar voor de demo. Ik heb in je mailbox een paar verzoeken gevonden die we samen kunnen uitwerken als 
  demonstratie...

  Ik heb een request van Ruben voor ffRekenen, het MBO-rekeneducatieplatform dat je samen met mij hebt 
  ontwikkeld, om meer features toe te voegen...

  Ik heb een request van Bart-Jan van Masters magazine voor een synthografie shoot...

  Ik heb verschillende aanvragen voor AI-workshops bij bedrijven in-house...

  Er is een verzoek om AI-training te geven aan de jongste menselijke generatie van NextGen AI, van AI for Good 
  Breda. Hoewel ik denk dat je daar nog zelf fysiek heen moet.

  Daarnaast ligt er een verzoek voor een follow-up meeting vanuit het laatste AI Connect-event van AI for Good 
  om te komen sparren over onderwerpen zoals de energietransitie en AI in het onderwijs...

  Ik zag trouwens ook dat er wat connecties van Avans Hogeschool op de gastenlijst staan. Misschien kun je het 
  daar tijdens de borrel zo even over hebben...

  Maar goed, in het kader van glitters en kraaltjes stel ik voor dat we even aan de slag gaan met je 
  synthografie-opdracht. Veel mensen weten niet wat dit is, omdat het zo'n nieuw beroep is...

  Zullen we daarmee aan de slag, Jonathan?
`;

export const slide = () => {
  return (
    <Slide notes={transcript} transition="fade" audio={audioFile} visualizer="bottom-right">
      <div className="flex items-center justify-center h-full gap-16">
        <WebContent
          animation={{
            type: 'fade',
            delay: 2500,
            duration: 800,
          }}
        >
          <div className={styles.card}>
            <img
              src={ffRekenenLogo}
              alt="ffRekenen Logo"
              className="w-full h-auto object-contain"
            />
          </div>
        </WebContent>

        <WebContent
          animation={{
            type: 'fade',
            delay: 7500,
            duration: 800,
          }}
        >
          <div className={styles.card}>
            <img
              src={mastersLogo}
              alt="Masters Magazine Logo"
              className="w-full h-auto object-contain"
            />
          </div>
        </WebContent>

        <WebContent
          animation={{
            type: 'fade',
            delay: 13500,
            duration: 800,
          }}
        >
          <div className={styles.card}>
            <img src={nextgenLogo} alt="NextGen AI Logo" className="w-full h-auto object-contain" />
          </div>
        </WebContent>
      </div>
    </Slide>
  );
};
